import { generateUtilityClass } from '@mui/material';
import { unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';

export interface ToastClasses {
  /** Styles applied to the root element. */
  root: string;
}

export type ToastClassKey = keyof ToastClasses;

export function getToastUtilityClass(slot: string): string {
  return generateUtilityClass('UnifyToast', slot);
}

export const toastClasses: ToastClasses = generateUtilityClasses('UnifyToast', [
  'root',
]);

export default toastClasses;
